<template>
  <section class="app-transporte">
    <v-container class="validacao-container">
      <v-card
        outlined
        class="app-card validacao-card"
      >
        <v-card-title class="app-card-title justify-center text-center">
          Validação de Certidão Veicular
        </v-card-title>

        <v-card-text class="app-card-content text-center">
          <section
            v-if="isLoading"
            class="status-panel"
          >
            <v-progress-circular
              color="primary"
              indeterminate
              :size="52"
              :width="5"
            />
            <p class="status-title">
              Validando certidão
            </p>
            <p class="status-description">
              Aguarde enquanto verificamos o token informado.
            </p>
          </section>

          <section
            v-else-if="notify.show"
            class="status-panel"
          >
            <div
              class="status-badge"
              :class="notify.type === 'success' ? 'status-badge-success' : 'status-badge-error'"
            >
              {{ notify.type === 'success' ? 'Token Válido' : 'Token inválido' }}
            </div>

            <h2
              class="status-title"
              :class="notify.type === 'success' ? 'success--text' : 'error--text'"
            >
              {{ notify.message }}
            </h2>

            <p class="status-description">
              {{
                notify.type === 'success'
                  ? 'A certidão consultada por este QR code foi confirmada pelo sistema.'
                  : certidao
                    ? 'A certidão foi localizada, mas a vigência informada não está mais válida.'
                    : 'Não foi possível confirmar a certidão a partir deste QR code.'
              }}
            </p>

            <div class="token-box">
              <span class="token-label">Código consultado</span>
              <strong class="token-value">{{ token || '-' }}</strong>
            </div>

            <div
              v-if="certidao"
              class="detalhes-box"
            >
              <span class="token-label">Informações da certidão</span>

              <v-row class="text-left">
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="detail-label">
                    Protocolo
                  </div>
                  <div class="detail-value">
                    {{ certidao.numProtocolo || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="detail-label">
                    Câmara
                  </div>
                  <div class="detail-value">
                    {{ certidao.camaraNome || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="detail-label">
                    Vereador(a)
                  </div>
                  <div class="detail-value">
                    {{ certidao.vereadorNome || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="detail-label">
                    CPF do vereador(a)
                  </div>
                  <div class="detail-value">
                    {{ formatCpf(certidao.vereadorCpf) }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Placa
                  </div>
                  <div class="detail-value">
                    {{ certidao.veiculoPlaca || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Renavam
                  </div>
                  <div class="detail-value">
                    {{ certidao.veiculoRenavam || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Cor
                  </div>
                  <div class="detail-value">
                    {{ certidao.veiculoCor || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="detail-label">
                    Modelo
                  </div>
                  <div class="detail-value">
                    {{ certidao.veiculoModelo || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Ano de fabricação
                  </div>
                  <div class="detail-value">
                    {{ certidao.veiculoAnoFabricacao || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Ano do modelo
                  </div>
                  <div class="detail-value">
                    {{ certidao.veiculoAnoModelo || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Vigência
                  </div>
                  <div class="detail-value">
                    {{ certidao.vigenciaInicio || '-' }} até {{ certidao.vigenciaFim || '-' }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Validade da apólice
                  </div>
                  <div class="detail-value">
                    {{ formatDate(certidao.dataValidadeApolice) }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="detail-label">
                    Chassi
                  </div>
                  <div class="detail-value">
                    {{ certidao.veiculoChassi || '-' }}
                  </div>
                </v-col>
              </v-row>
            </div>
          </section>
        </v-card-text>
      </v-card>
    </v-container>
  </section>
</template>

<script>
import cpvService from '@/services/cpv/cpv.service';

export default {
  name: 'CpvCertidaoVeiculoValidar',

  metaInfo: {
    title: 'Validar Certidão Veicular - CPV - Central de Serviços',
  },

  data: () => ({
    token: '',
    isLoading: false,
    certidao: null,
    notify: {
      show: false,
      type: null,
      message: null,
    },
  }),

  mounted() {
    this.validarCertidao();
  },

  methods: {
    formatCpf(value) {
      const digits = String(value || '').replace(/\D/g, '');

      if (digits.length !== 11) {
        return value || '-';
      }

      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },

    formatDate(value) {
      const normalized = String(value || '').trim();

      if (!normalized) {
        return '-';
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(normalized)) {
        return normalized;
      }

      if (/^\d{4}-\d{2}-\d{2}/.test(normalized)) {
        const [year, month, day] = normalized.slice(0, 10).split('-');
        return `${day}/${month}/${year}`;
      }

      return normalized;
    },

    normalizeErrorMessage(message) {
      return String(message || '')
        .replace(/^\s*erro\s*:\s*/i, '')
        .trim();
    },

    validarCertidao() {
      this.token = String(this.$route.query.token || '').trim();

      if (!this.token) {
        this.certidao = null;
        this.notify = {
          show: true,
          type: 'error',
          message: 'QR code inválido ou incompleto.',
        };
        return;
      }

      this.isLoading = true;

      cpvService.validateCertidaoVeicular(this.token).subscribe({
        next: res => {
          this.isLoading = false;
          this.certidao = res?.result || null;

          const vigenciaValida = !!this.certidao?.vigenciaValida;

          this.notify = {
            show: true,
            type: vigenciaValida ? 'success' : 'error',
            message: vigenciaValida
              ? 'Certidão veicular válida.'
              : 'Certidão veicular fora da vigência.',
          };
        },
        error: err => {
          this.isLoading = false;
          this.certidao = null;

          const rawMessage =
            err?.response?.data?.message ||
            err?.response?.data?.mensagem ||
            err?.response?.data?.error ||
            'Não foi possível validar a certidão veicular.';

          this.notify = {
            show: true,
            type: 'error',
            message: this.normalizeErrorMessage(rawMessage),
          };
        },
      });
    },
  },
};
</script>

<style scoped>
.validacao-container {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
}

.validacao-card {
  width: 100%;
  max-width: 720px;
}

.status-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px 16px;
}

.status-badge {
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.status-badge-success {
  background: #e8f5e9;
  color: #1b5e20;
}

.status-badge-error {
  background: #ffebee;
  color: #b71c1c;
}

.status-title {
  margin: 0;
  font-size: 2rem;
  line-height: 1.2;
  font-weight: 700;
}

.status-description {
  margin: 0;
  max-width: 480px;
  color: rgba(0, 0, 0, 0.68);
  font-size: 1rem;
  line-height: 1.6;
}

.token-box {
  width: 100%;
  max-width: 520px;
  padding: 16px 20px;
  border-radius: 16px;
  background: #f5f7fa;
  border: 1px solid #dfe5ec;
}

.token-label {
  display: block;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.token-value {
  display: block;
  word-break: break-word;
  font-size: 1rem;
}

.detalhes-box {
  width: 100%;
  max-width: 640px;
  padding: 20px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #dfe5ec;
}

.detail-label {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.detail-value {
  font-size: 1rem;
  font-weight: 500;
  word-break: break-word;
}
</style>
